//#region src/scripts/extenders/search-header.js
var SearchHeader = class extends HTMLElement {
	constructor() {
		super();
		const searchToggle = this.querySelector(".search-toggle");
		const inputField = this.querySelector(".utilities__search");
		this.querySelector(".icon-x").addEventListener("click", () => {
			inputField.classList.remove("js-active");
		});
		searchToggle.addEventListener("click", () => {
			inputField.classList.toggle("js-active");
			console.log("hallo");
		});
	}
};
if (customElements.get("search-header") === void 0) customElements.define("search-header", SearchHeader);
//#endregion
